import { Phone } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { CONTACT, waLink } from "@/data/site";

export default function StickyMobileCTA() {
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-px border-t border-gold/20 bg-gold/20 md:hidden"
    >
      <a
        href={CONTACT.phoneTel}
        data-testid="sticky-call-button"
        className="glass-dark flex items-center justify-center gap-2 py-4 text-sm font-semibold text-gold"
      >
        <Phone size={16} /> Call Now
      </a>
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-whatsapp-button"
        className="glass-dark flex items-center justify-center gap-2 py-4 text-sm font-semibold text-[#25D366]"
      >
        <WhatsAppIcon size={16} /> WhatsApp Us
      </a>
    </div>
  );
}
